import { CommentCollectionItem } from 'Frontend/scripts/models/communityNews.model'
import { FunctionComponent, useMemo, useState } from 'react'
import Comment from './Comment'
import { Button, Nav, Tab } from 'react-bootstrap'
import AddComment from './AddComment'
import { useTranslation } from 'react-i18next'

interface CommentsProps extends CommentCollectionItem {
  contentId: number
  onPostAdded?: () => void
  onPostDeleted?: () => void
}

const Comments: FunctionComponent<CommentsProps> = ({
  comments,
  hasCurrentUserAccessToDeleteComment,
  contentId,
  onPostAdded,
  onPostDeleted,
}) => {
  const { t } = useTranslation()

  const [activeKey, setActiveKey] = useState<string>('')
  const hasComments = useMemo(() => {
    return comments.length > 0
  }, [comments])

  return (
    <Tab.Container activeKey={activeKey} onSelect={(k) => setActiveKey(k as string)}>
      <Nav variant="tabs" className="mt-3 border-0 comments__toggler">
        <Nav.Item className="p-0">
          <Nav.Link className="p-0 border-0 bg-transparent text-primary" eventKey="comments">
            {t('comments.comment')} ({comments.length})
          </Nav.Link>
        </Nav.Item>
      </Nav>
      <Tab.Content>
        <Tab.Pane eventKey="comments">
          <Button variant="link" className="p-0 mt-2" onClick={() => setActiveKey('')}>
            {t('comments.hide-comments')}
          </Button>
          <br />
          <div className="comments">
            {hasComments ? (
              <>
                {comments?.map((comment) => (
                  <Comment
                    onPostDeleted={() => onPostDeleted && onPostDeleted()}
                    hasCurrentUserAccessToDeleteComment={hasCurrentUserAccessToDeleteComment}
                    key={comment.id.storeId}
                    {...comment}
                  />
                ))}
              </>
            ) : (
              <p className="comments__empty">{t('comments.no-comments')}</p>
            )}
            <AddComment
              contentId={contentId}
              onPostAdded={() => {
                console.log('tar emot att den skapats')
                onPostAdded && onPostAdded()
              }}
            />
          </div>
        </Tab.Pane>
      </Tab.Content>
    </Tab.Container>
  )
}

export default Comments
